export default function VMAMasterVendorsDirectiveController() {}
